export class Role {
    name: string;
    description: string;
    permissions: string[];
    id: number;
}
